import styled from 'styled-components';
import { typography, color, spacing } from '../../style/theme';
import { getFontSize } from '../../utils/helpers';
var JumboText = styled.p.withConfig({
  displayName: "JumboText",
  componentId: "ddjp86-0"
})(["", ";font-weight:500;color:", ";margin-bottom:", "px;@media only screen and (max-width:", "px){font-size:", "rem;line-height:3rem;margin-bottom:", "px;}"], getFontSize(typography.jumbo), color.secondary1, spacing.base * 2, spacing.collapseMenuWidth, typography.large, spacing.base);
export default JumboText;